/* tslint:disable */
import 'reflect-metadata/Reflect';
import 'zone.js/dist/zone';



// WEBPACK FOOTER //
// ./src/main/webapp/app/polyfills.ts